module.exports = {
    API_BASE_URL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:8080/api' || 'https://serene-citadel-94389.herokuapp.com/api',
}


// WEBPACK FOOTER //
// ./src/config.js